import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "../constants";
import Logo from "./Logo";
import colors from "../theme/colors";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const headerStyle = {
    backgroundColor: colors.bgCard,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    borderBottom: `1px solid ${colors.bgBorder}`,
  };

  const navLinkStyle = (active) => ({
    color: active ? colors.textPrimary : colors.textMuted,
    borderBottom: active ? `2px solid ${colors.accentCyan}` : "2px solid transparent",
    paddingBottom: "4px",
    transition: "color 0.2s ease, border-color 0.2s ease",
  });

  const ctaStyle = {
    backgroundColor: colors.accentBlue,
    color: colors.textPrimary,
    borderRadius: "8px",
    transition: "background-color 0.2s ease, transform 0.2s ease",
  };

  const iconBarStyle = { backgroundColor: colors.textMuted };

  return (
    <header className="sticky top-0 z-50" style={headerStyle}>
      <nav className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-6 py-3 sm:py-4">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="Prime Network home">
          <span
            className="inline-block h-1.5 w-1.5 shrink-0 rounded-full"
            style={{ backgroundColor: colors.statusGreen, boxShadow: `0 0 8px ${colors.statusGreen}` }}
            aria-hidden
          />
          <Logo variant="compact" navBrand />
        </Link>

        <button
          className="rounded-lg p-3 md:hidden"
          style={{
            border: `1px solid ${colors.bgBorder}`,
            backgroundColor: colors.bgCard,
          }}
          onClick={() => setIsOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          type="button"
        >
          <span className="block h-0.5 w-5" style={iconBarStyle} />
          <span className="mt-1.5 block h-0.5 w-5" style={iconBarStyle} />
          <span className="mt-1.5 block h-0.5 w-5" style={iconBarStyle} />
        </button>

        <ul
          className={`${isOpen ? "flex" : "hidden"} absolute left-0 top-full z-40 w-full flex-col gap-2 border-b p-4 backdrop-blur-xl sm:p-6 md:static md:flex md:w-auto md:flex-row md:items-center md:gap-6 md:border-0 md:bg-transparent md:p-0`}
          style={{
            borderColor: colors.bgBorder,
            backgroundColor: colors.bgCard,
          }}
        >
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className="block rounded-lg px-3 py-3 text-base font-medium md:inline-block md:px-0 md:py-1 md:text-sm"
                style={navLinkStyle(isActive(item.path))}
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/contact"
              className="inline-flex min-h-[44px] items-center justify-center px-5 py-3 text-sm font-semibold shadow-lg transition hover:-translate-y-0.5"
              style={ctaStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = colors.accentCyan;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = colors.accentBlue;
              }}
              onClick={() => setIsOpen(false)}
            >
              Get Free Consultation
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
